import { render, staticRenderFns } from "./groups.vue?vue&type=template&id=29344fb3&scoped=true"
import script from "./groups.vue?vue&type=script&lang=js"
export * from "./groups.vue?vue&type=script&lang=js"
import style0 from "./groups.vue?vue&type=style&index=0&id=29344fb3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29344fb3",
  null
  
)

export default component.exports